import { IPaymentResult, PaymentIntentSecrets } from '@/app/trust-pay/trust-pay-api';

export const appleButtonStyles = {
  '--apple-pay-button-width': '100%;',
  '--apple-pay-button-height': '54px;',
  '--apple-pay-button-border-radius': '4px;',
  '--apple-pay-button-padding': '5px 0px;',
};

type GenerateAppleButtonParams = {
  secrets: PaymentIntentSecrets;
  paymentIntentId: string;
  appleInitResultData: object | null;
  buttonLocale: string;
  buttonType: string;
  handlePaymentProcessed: (result: IPaymentResult) => void;
};

export const generateApplePayButton = ({
  secrets,
  appleInitResultData,
  buttonLocale,
  buttonType,
  handlePaymentProcessed,
}: GenerateAppleButtonParams): Promise<void> => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.TrustPayApi) {
        const error = new Error('TrustPayApi is not available on window');
        console.error(error);
        return reject(error);
      }

      const api = new window.TrustPayApi(secrets);

      const applePayButton = api.createComponent('applePay', {
        initiativeContext: window.location.host,
        style: appleButtonStyles,
        buttonStyle: 'black',
        buttonType,
        buttonLocale,
        onPaymentProcessed: handlePaymentProcessed,
        paymentRequest: appleInitResultData,
      });

      console.info('Created Apple Pay component:', applePayButton);

      try {
        const isSupported = await applePayButton.isSupported();
        console.info('Apple Pay isSupported result:', isSupported);

        if (isSupported) {
          if (!applePayButton.isMounted) {
            applePayButton.mount('#apple-pay-element');
          }
          console.info('Apple Pay button mounted');
          resolve();
        } else {
          const error = new Error('Apple Pay is not supported on this device/browser.');
          console.warn(error.message);
          reject(error);
        }
      } catch (err) {
        console.error('Error during Apple Pay support check or mount:', err);
        reject(err);
      }
    } catch (err) {
      console.error('Unexpected error in generateApplePayButton:', err);
      reject(err);
    }
  });
};
